export default __webpack_public_path__ + "static/media/full-hd-low.ec12a89c.webm";